import React from 'react';
import { Box, useTheme } from '@mui/material';

const DayHeader = ({ dayIndex, day, formatDay, dayWidth }) => {
  const theme = useTheme();
  const isBaseDateDay = dayIndex === 0;
  const isWeekend = day.getDay() === 6 || day.getDay() === 0;

  return (
    <Box
      sx={{
        width: dayWidth,
        minWidth: dayWidth,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: isBaseDateDay ? 'yellow' : 'white',
        fontSize: '14px',
        fontWeight: isBaseDateDay ? 700 : 500,
        borderRight: `2px solid ${theme.palette.grey[500]}`,
        bgcolor: isWeekend ? 'grey.700' : 'grey.600',
        position: 'relative'
      }}
    >
      {formatDay(day)}
      {isBaseDateDay && (
        <Box sx={{
          position: 'absolute',
          bottom: -2,
          left: '50%',
          transform: 'translateX(-50%)',
          width: 0,
          height: 0,
          borderLeft: '6px solid transparent',
          borderRight: '6px solid transparent',
          borderTop: '6px solid yellow'
        }} />
      )}
    </Box>
  );
};

export default DayHeader;
